import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    payoffAmount: {
      inputType: 'text',
      type: 'thousandSep',
      title: 'Payoff Amount',
      prefix: '$',
      required: true,
    },
    payoffDate: {
      inputType: 'text',
      type: 'date',
      title: 'Good through Date',
      required: true,
    },
  }
}
